import { ReactElement } from "react";
import { Interaction } from "../Interaction";

export enum ePostType {
  "news" = 1,
  "highlight" = 2,
}

export interface AssetDetails {
  id: number;
  name: string;
  symbol: string;
  exchange: string;
  type: number;
  country_code: number;
  currency_symbol: string;
  icon?: string;
  link?: string;
}

export interface Post {
  id: number;
  asset_id: number;
  content: string;
  image?: string;
  url?: string;
  type: ePostType;
  created_at: Date;
  updated_at: Date;
  interactions: Interaction[];
  asset_details: AssetDetails;
}

export type ReactionContent =
  | "love"
  | "funny"
  | "cry"
  | "up"
  | "down";

export interface Reaction {
  content: ReactionContent;
  description: string;
  icons: {
    checked: ReactElement;
    unchecked: ReactElement;
  };
  status: boolean;
  interactionId?: number;
}


export interface UpdateInteractionRequest {
  content: string;
}

export interface IconStatus {
  checked: ReactElement;
  unchecked: ReactElement;
  smallChecked: ReactElement;
}

export interface ReactionsIconsByContent {
  love: IconStatus,
  funny: IconStatus,
  cry: IconStatus,
  up: IconStatus,
  down: IconStatus
}

export interface ReactionSummary {
  qnt: number,
  items: Interaction[],
  icon: ReactElement
}
export interface ReactionsSummary {
  love: ReactionSummary,
  funny: ReactionSummary,
  cry: ReactionSummary,
  up: ReactionSummary,
  down: ReactionSummary
}

export type Content = "love" | "funny" | "cry" | "up" | "down";

export interface ReportableItem {
  newsId: number | null;
  content: string,
  image: string,
  url: string,
  type: ePostType,
  asset_id: number
}

export interface LastSaveDetails {
  time: string
}